import { DEFAULT_FONT_FAMILY } from 'common/constants';
import styled from 'styled-components';

interface IStyleProps {
  posX?: number;
  posY?: number;
  displayValue?: string;
  colorValue?: string;
}

export const Root = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  position: absolute;
  left: ${(props: IStyleProps) => (props.posX ?? 0)}px;
  top: ${(props: IStyleProps) => (props.posY ?? 0)}px;
  width: 642px;
  border-radius: 5px;
  border: solid 1px rgba(189, 189, 189, 0.2);
  margin-bottom: 200px;
  background-color: #fff;
`;

export const TopContent = styled.div`
  margin: 37px 62px 0px 62px;
`;

export const BoxTitle = styled.div`
  font-weight: 500;
  display: flex;
  justify-content: space-between;
`;

export const BoxWarning = styled.div`
  padding-right: 11px;
  font-weight: normal;
  color: ${(props: IStyleProps) => (props.colorValue ?? 'auto')};
`;

export const InputContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  margin: 20px 0px 7px 0px;
`;

export const LoopIconContainer = styled.div`
  position: absolute;
  left: 14px;
  top: 13px;
`;

export const SearchInput = styled.input`
  width: 453px;
  height: 31px;
  box-sizing: border-box;
  padding: 0px 4px 0px 34px;
  border-radius: 5px;
  border: solid 2px #e7e7ec;
  background-color: #fff;
`;

export const FilterButton = styled.div`
  margin-left: 5px;
`;

export const ChipsContainer = styled.div`
  display: flex;
  align-items: center;
  height: 31px;
  margin: 0px 62px 0px 62px;
  display: ${(props: IStyleProps) => (props.displayValue ?? `auto`)};
`;

export const MiddleContent = styled.div`
  padding-top: 10px;
  max-height: 695px;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const ReviewCardContainer = styled.div`
  width: 507px;
  margin: 0px 62px 9px 62px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(189, 189, 189, 0.5);
`;

export const BottomContent = styled.div`
  padding: 28px 47px;
`;

export const DragContainer = styled.div`
`;

export const ActionsContainer = styled.div`
  margin: 5px 15px 0px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AutomaticScroll = styled.div`
`;

export const AutomaticScrollContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const AutomaticScrollTitle = styled.div`
  font-size: 12px;
  color: #2d3548;
  margin-right: 5px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
`;